import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import "../../assets.js";
import "../has.js";
import "../urlUtils.js";
var a = null;
var s = {};

function e(a, s) {
  var _iterator = _createForOfIteratorHelper(a),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _e = _step.value;
      if (_e.name === s.name) return;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  a.push(s);
}

function r(a) {
  var r;
  var n = {
    async: a.async,
    isDebug: a.isDebug,
    locale: a.locale,
    baseUrl: a.baseUrl,
    has: _objectSpread({}, a.has),
    map: _objectSpread({}, a.map),
    packages: a.packages && a.packages.concat() || [],
    paths: _objectSpread({}, a.paths)
  };
  return a.hasOwnProperty("async") || (n.async = !0), a.hasOwnProperty("isDebug") || (n.isDebug = !1), a.baseUrl || (n.baseUrl = s.baseUrl), null == (r = s.packages) || r.forEach(function (a) {
    e(n.packages, a);
  }), n;
}

export { a as DEFAULT_LOADER_URL, r as default };